import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ApiHttp } from 'app/providers';
import { OperatorModel, OperatorSignUpResponse } from 'app/components/operator/operator-signup/OperatorModel';

@Injectable()
export class OperatorService {
    constructor(private apiHttp: ApiHttp) {
    }

    public getPayoutBreakdown(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressOperator/GetPayoutBreakdown', data, messageService);
    }

    public getTripsGroupByDate(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressOperator/GetTripsGroupByDate', data, messageService);
    }

    public getOperatorTransactions(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressOperator/GetOperatorTransactions', data, messageService);
    }

    public exportOperatorFinance(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.postDownloadFile('api/AdminXpressOperator/ExportOperatorFinance', data, messageService);
    }

    public getOperatorFinance(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressOperator/GetOperatorFinance', data, messageService);
    }

    public getOperatorReports(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressOperator/GetOperatorReports', data, messageService);
    }

    public getOperatorBookingHistory(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressOperator/GetOperatorBookingHistory', data, messageService);
    }

    public exportOperatorReports(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.postDownloadFile('api/AdminXpressOperator/ExportOperatorReports', data, messageService);
    }

    public checkEmailExist(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressOperator/CheckEmailExist', data, messageService);
    }

    public signUp(data: any, messageService: MessageService): Promise<OperatorSignUpResponse|any> {
        return this.apiHttp.post('api/AdminXpressOperator/SignUp', data, messageService);
    }

    public uploadDocuments(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressOperator/UploadDocuments', data, messageService);
    }

    public deleteDocuments(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressOperator/DeleteDocuments', data, messageService);
    }

    public updateAccount(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressOperator/UpdateAccount', data, messageService);
    }

    public resetOperatorPassword(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressOperator/ResetOperatorPassword', data, messageService);
    }

    public setOperatorPasswordFromResetSession(data: { ProcessId: string; NewPassword: string; ConfirmPassword: string }, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/XpressUser/NewUserPassword', data, messageService);
    }

    public resendOperatorOTP(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/Otp/ResendOTP', data, messageService);
    }

    public addVehicle(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressOperator/AddVehicle', data, messageService);
    }

    public updateOperatorVehicleDocuments(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressOperator/UpdateOperatorVehicleDocuments', data, messageService);
    }

    public uploadDocument(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressOperator/UploadDocument', data, messageService);
    }

    public uploadImage(data: FormData, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/Image/UploadImage', data, messageService);
    }

    public deleteImage(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/Image/DeleteImage', data, messageService);
    }

    public updateDocumentExpiryDates(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/Image/UpdateDocumentExpiryDates', data, messageService);
    }

    public getOperatorVehicles(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressOperator/GetOperatorVehicles', data, messageService);
    }

    public getOperators(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressOperator/GetOperators', data, messageService);
    }

    public exportOperators(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.postDownloadFile('api/AdminXpressOperator/ExportOperators', data, messageService);
    }

    public getOperatorVehicle(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressOperator/GetOperatorVehicle', data, messageService);
    }

    public updateVehicleOperatorSchedule(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressOperator/UpdateVehicleOperatorSchedule', data, messageService);
    }

    public getOperatorVehicleStatistics(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressOperator/GetOperatorVehicleStatistics', data, messageService);
    }

    public activeOrInactiveVehicle(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressOperator/ActiveOrInactiveVehicle', data, messageService);
    }

    public preCreateOperator(data: OperatorModel, messageService: MessageService): Promise<OperatorSignUpResponse | any> {
        return this.apiHttp.post('api/AdminXpressOperator/PreCreateOperator', data, messageService);
    }

    public getWebConfig(messageService?: MessageService): Promise<{
        ShowConnexService?: boolean;
        OperatorPortalHiddenMenusEnabled?: boolean;
        OperatorPortalBirDocumentUpload?: boolean;
        OperatorPortalBusinessPermitDocumentUpload?: boolean;
        OperatorPortalDtiSecDocumentUpload?: boolean;
        OperatorPortalLtfrbDocumentUpload?: boolean;
        CommandCenter?: unknown;
        Success?: boolean;
    } | any> {
        return this.apiHttp.post('api/Config/GetWebConfig', {}, messageService);
    }
}
